import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../components/Card";
import Chip from "../../components/Dashboard/Chip";
import { getReferralAudit } from "../../api/referrals.admin.service";
import { CursorPager, JsonBlock, useCursorList, useErrorText, useFormat } from "./shared";
import styles from "./Referrals.module.sass";

const ENTITIES = ["program", "settings", "code", "attribution", "reward", "user"];

/** Auditoría (06 §2.8): quién, qué, antes y después, y cuándo. */
const AuditTab = () => {
  const { t } = useTranslation();
  const fmt = useFormat();
  const errorText = useErrorText();
  const [filters, setFilters] = useState({ entityType: "", entityId: "", actorUserId: "" });
  const [open, setOpen] = useState(null);
  const list = useCursorList(getReferralAudit, { ...filters, limit: 40 });

  return (
    <Card className={styles.card}>
      <div className={styles.filters}>
        {ENTITIES.map((e) => (
          <Chip
            key={e}
            on={filters.entityType === e}
            onClick={() => setFilters((f) => ({ ...f, entityType: f.entityType === e ? "" : e }))}
          >
            {t(`referrals.audit.entity_${e}`)}
          </Chip>
        ))}
        <input
          className={styles.search}
          placeholder={t("referrals.audit.entityId")}
          value={filters.entityId}
          onChange={(e) => setFilters((f) => ({ ...f, entityId: e.target.value.trim() }))}
        />
        <input
          className={styles.search}
          placeholder={t("referrals.audit.actor")}
          value={filters.actorUserId}
          onChange={(e) => setFilters((f) => ({ ...f, actorUserId: e.target.value.trim() }))}
        />
      </div>
      {list.error && <div className={styles.empty}>{errorText(list.error)}</div>}
      {!list.error && list.items.length === 0 && (
        <div className={styles.empty}>{list.loading ? t("referrals.common.loading") : t("referrals.common.noData")}</div>
      )}
      <div className={styles.table}>
        {list.items.map((a) => (
          <div key={a.id}>
            <button type="button" className={styles.row} onClick={() => setOpen(open === a.id ? null : a.id)}>
              <code className={styles.actionCell} title={a.action}>{a.action}</code>
              <div className={styles.rowMain}>
                <div className={styles.rowTitle}>
                  {t(`referrals.audit.entity_${a.entityType}`, { defaultValue: a.entityType })} · <code>{a.entityId}</code>
                </div>
                <div className={styles.muted}>
                  {a.actorRole}
                  {a.actorUserId ? ` · ${a.actorUserId}` : ""}
                  {a.reason ? ` · “${a.reason}”` : ""}
                </div>
              </div>
              <div className={styles.muted}>{fmt.dateTime(a.at)}</div>
            </button>
            {open === a.id && (
              <div className={styles.auditBody}>
                <div>
                  <div className={styles.sectionTitle}>{t("referrals.audit.before")}</div>
                  <JsonBlock value={a.before ?? null} />
                </div>
                <div>
                  <div className={styles.sectionTitle}>{t("referrals.audit.after")}</div>
                  <JsonBlock value={a.after ?? null} />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <CursorPager list={list} />
    </Card>
  );
};

export default AuditTab;
